export type UpdateItem = {
    id: number;
    title: string;
    description: string;
    image: string;
    buttonText?: string;
    longDescription?: string;
};

export const latestUpdates: UpdateItem[] = [
    {
        id: 1,
        title: "Copilot Beta Launch!",
        description:
            "Be among the first to try the new Delphos Copilot platform and start writing music faster than ever.",
        image:
            "/1.jpg",
        buttonText: "Read more",
        longDescription:
            "This is the dawn of a new workflow for composers, producers and editors. We’re excited to announce the public beta release of Delphos Copilot. A musical intelligence that will help you write faster, think of ideas and get to a finished track in a fraction of the time.",
    },
    {
        id: 2,
        title: "Launching: Fast Track",
        description:
            "Turn any loop, hook or sketch into new full instrumentals in minutes.",
        image:
            "/2.jpg",
        buttonText: "Read more",
        longDescription:
            "Getting to the winning idea for a composition is often the hardest part. But what comes after determines whether or not a song is finished and gets released.",
    },
    {
        id: 3,
        title: "Soundworld Library",
        description:
            "Introducing new single instrument soundworlds!",
        image:
            "/3.jpg",
        buttonText: "Read more",
        longDescription:
            "To celebrate the Copilot Beta, we have updated our roster of soundworlds.",
    },
    {
        id: 4,
        title: "Audio Utilities",
        description:
            "Stem separation, mastering and chord detection",
        image:
            "/4.jpg",
        buttonText: "Read more",
        longDescription:
            "To keep essential audio editing functionalities in one place, we’ve now added stem separation, auto mastering and chord detection to the Copilot.",
    },
];


